<template>
  <div
    class="scroll-up"
    :class="{ 'scroll-up--active': isActive }"
    @click="scrollToTop">
    <div class="scroll-up__arrow" />
  </div>
</template>

<script>
import { supportsPassiveEvent, scrollTo, throttle } from 'Root/helpers/tools';

export default {
  name: 'ScrollUp',

  data() {
    return {
      currentPosition: typeof window !== 'undefined' ? window.pageYOffset : null,
    };
  },

  computed: {
    isActive() {
      if (typeof window !== 'undefined') {
        return this.currentPosition > window.innerHeight / 2;
      }
      return false;
    },
  },

  mounted() {
    const throttledScroll = throttle(() => {
      this.currentPosition = window.pageYOffset;
    }, 300);

    window.addEventListener('scroll', throttledScroll, supportsPassiveEvent ? { passive: true } : false);
  },

  methods: {
    scrollToTop() {
      scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
  .scroll-up {
    z-index: 111;
    position: fixed;
    bottom: 8rem;
    right: 1rem;
    background: $color--additional-gray;
    width: 4rem;
    height: 4rem;
    border: 2px solid $color--basic-dark-gray;
    border-radius: 8px;
    transition: opacity .3s ease-out, bottom .3s ease-out, transform 0.15s;
    opacity: 0;
    visibility: hidden;
    cursor: pointer;

    &--active {
      opacity: 1;
      visibility: visible;
    }
  }

  .scroll-up__arrow {
    position: relative;
    display: block;
    left: calc(50% - 1px);
    top: 35%;
    width: 2px;
    height: 1.5rem;
    background: $color--basic-dark-gray;

    &:before {
      content: '';
      display: block;
      transform: rotate(45deg) translate(-35%, 25%);
      border-top: 2px solid $color--basic-dark-gray;
      border-left: 2px solid $color--basic-dark-gray;
      width: 0.8rem;
      height: 0.8rem;
    }
  }
</style>
